import createIcon from '../../createIcon';

/**
 * @component @name Upcoming
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMTYgNy4yNkwxOS43NSA1Ljg1TDE2LjE5IDkuNEwxNy42IDEwLjgxQzE3LjYgMTAuODEgMjEuMDUgNy4yOSAyMS4xNiA3LjI2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzIDNIMTFWOEgxM1YzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTYuNCAxMC44MUw3LjgxIDkuNEw0LjI2IDUuODRMMi44NCA3LjI2QzIuOTUgNy4yOSA2LjQgMTAuODEgNi40IDEwLjgxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDEySDE1QzE1IDEzLjY2IDEzLjY2IDE1IDEyIDE1QzEwLjM0IDE1IDkgMTMuNjYgOSAxMkg0QzIuOSAxMiAyIDEyLjkgMiAxNFYxOUMyIDIwLjEgMi45IDIxIDQgMjFIMjBDMjEuMSAyMSAyMiAyMC4xIDIyIDE5VjE0QzIyIDEyLjkgMjEuMSAxMiAyMCAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Upcoming = createIcon('Upcoming', [
  [
    'path',
    {
      d: 'M21.16 7.26L19.75 5.85L16.19 9.4L17.6 10.81C17.6 10.81 21.05 7.29 21.16 7.26Z',
      key: 'fy8iuu',
    },
  ],
  ['path', { d: 'M13 3H11V8H13V3Z', key: 'c95ouj' }],
  [
    'path',
    { d: 'M6.4 10.81L7.81 9.4L4.26 5.84L2.84 7.26C2.95 7.29 6.4 10.81 6.4 10.81Z', key: '1y7ajf' },
  ],
  [
    'path',
    {
      d: 'M20 12H15C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12H4C2.9 12 2 12.9 2 14V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V14C22 12.9 21.1 12 20 12Z',
      key: 'st3ers',
    },
  ],
]);

export default Upcoming;
